enum ProductsActions {
    FETCH_LIST = "productsFetchList",
    GET_ITEM = "productsGetItem",
    CREATE_ITEM = "productsCreateItem",
    UPDATE_ITEM = "productsUpdateItem",
    DELETE_ITEM = "productsDeleteItem",
    REFRESH_LIST = "productsRefreshList",
    UPDATE_DESCRIPTION = "productsUpdateDescription",
    UPLOAD_IMAGE = "productsUploadImage",
    DELETE_IMAGE = "productsDeleteImage",
    SORT_IMAGES = "productsSortImages",
    FETCH_VARIANTS = "productsFetchVariants",
    CREATE_VARIANT = "productsCreateVariant",
    UPDATE_VARIANT = "productsUpdateVariant",
    DELETE_VARIANT = "productsDeleteVariant",
    FETCH_CATEGORIES = "productsFetchCategories",
    UPDATE_CATEGORIES = "productsUpdateCategories",
    FETCH_ATTRIBUTES = "productsFetchAttributes",
    UPDATE_ATTRIBUTES = "productsUpdateAttributes",
    FETCH_INGREDIENTS = "productsFetchIngredients",
    UPDATE_INGREDIENTS = "productsUpdateIngredients",
    FETCH_GRADUATED_PRICES = "productsFetchGraduatedPrices",
    UPDATE_GRADUATED_PRICES = "productsUpdateGraduatedPrices",
    FETCH_CROSS_SELLING = "productsFetchCrossSelling",
    UPDATE_CROSS_SELLING = "productsUpdateCrossSelling",
    FETCH_INVENTORY = "productsFetchInventory",
    ADD_INVENTORY = "productsAddInventory",
    MOVE_INVENTORY = "productsMoveInventory",
    DELETE_INVENTORY = "productsDeleteInventory",
    FETCH_DELIVERY_OPTIONS = "productsFetchDeliveryOptions",
    UPDATE_DELIVERY_OPTIONS = "productsUpdateDeliveryOptions",
    // Videos //
    FETCH_VIDEOS = "productsFetchVideos",
    UPLOAD_VIDEO = "productsUploadVideo",
    DELETE_VIDEO = "productsDeleteVideo",
    // Downloads //
    FETCH_DOWNLOADS = "productsFetchDownloads",
    UPLOAD_DOWNLOAD = "productsUploadDownload",
    DELETE_DOWNLOAD = "productsDeleteDownload",
    // Facetten //
    FETCH_FACETTES = "productsFetchFacettes",
    UPDATE_FACETTES = "productsUpdateFacettes",
    // Produktionen //
    FETCH_PRODUCTIONS = "productsFetchProductions",
    CREATE_PRODUCTION = "productsCreateProduction",
    DELETE_PRODUCTION = "productsDeleteProduction",
    // Inventory Overview + Alerts //
    FETCH_INVENTORY_OVERVIEW = "productsFetchInventoryOverview",
    FETCH_INVENTORY_ALERTS = "productsFetchInventoryAlerts",
    // EAN Lookup //
    LOOKUP_EAN = "productsLookupEan",
    // Inventory Movements //
    FETCH_INVENTORY_MOVEMENTS = "productsFetchInventoryMovements",
}

enum ProductsMutation {
    SET_RENDER_UPDATE = "productsListRenderNeeded",
    SET_LIST_RESULT = "productsListResult",
    SET_INVENTORY_OVERVIEW = "productsInventoryOverview",
    SET_INVENTORY_ALERTS = "productsInventoryAlerts"
}

export { ProductsActions, ProductsMutation };
